import { render, staticRenderFns } from "./NewLanding.vue?vue&type=template&id=e0b734ca&scoped=true"
import script from "./NewLanding.vue?vue&type=script&lang=js"
export * from "./NewLanding.vue?vue&type=script&lang=js"
import style0 from "./NewLanding.vue?vue&type=style&index=0&id=e0b734ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b734ca",
  null
  
)

export default component.exports